import React, { useState } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
} from "react-bootstrap";

import {
  RiAddLine,
  RiDeleteBin6Line,
  RiFileList3Line,
} from "react-icons/ri";

import styles from "./ProductSpecification.module.css";

const TYPES = {
  ONLY_SPECIFICATION: "ONLY_SPECIFICATION",
  TITLE_SPECIFICATION: "TITLE_SPECIFICATION",
  FULL: "FULL",
};

const ProductSpecification = () => {
  const [type, setType] = useState(
    TYPES.ONLY_SPECIFICATION
  );

  const [bulkText, setBulkText] = useState("");

  const [specifications, setSpecifications] =
    useState([
      {
        mainTitle: "",
        title: "",
        specification: "",
      },
    ]);

  const handleChange = (
    index,
    field,
    value
  ) => {
    const updated = [...specifications];

    updated[index][field] = value;

    setSpecifications(updated);
  };

  /* Add Row At Top */

  const addRow = () => {
    setSpecifications((prev) => [
      {
        mainTitle: "",
        title: "",
        specification: "",
      },
      ...prev,
    ]);
  };

  const removeRow = (index) => {
    const updated = [...specifications];

    updated.splice(index, 1);

    setSpecifications(updated);
  };

  /* Bulk Create */

  const handleBulkCreate = () => {
    if (!bulkText.trim()) return;

    const lines = bulkText
      .split("\n")
      .filter((line) => line.trim());

    const generated = lines.map((line) => {
      const parts = line
        .split("|")
        .map((item) => item.trim());

      /* Only Specification */

      if (
        type === TYPES.ONLY_SPECIFICATION
      ) {
        return {
          mainTitle: "",
          title: "",
          specification: line.trim(),
        };
      }

      /* Title + Specification */

      if (
        type === TYPES.TITLE_SPECIFICATION
      ) {
        return {
          mainTitle: "",
          title: parts[0] || "",
          specification: parts[1] || "",
        };
      }

      /* Full */

      return {
        mainTitle: parts[0] || "",
        title: parts[1] || "",
        specification: parts[2] || "",
      };
    });

    /* Add Generated Rows At Top */

    setSpecifications((prev) => [
      ...generated,
      ...prev,
    ]);

    setBulkText("");
  };

  return (
    <div>
      {/* Header */}

      <div className={styles.topBar}>
        <div className={styles.topTitle}>
          Product Specifications
        </div>

        <Button
          className={styles.addBtn}
          onClick={addRow}
        >
          <RiAddLine size={14} />
          Add Row
        </Button>
      </div>

      {/* Bulk Create */}

      <Card className={styles.bulkCard}>
        <Card.Body className={styles.bulkBody}>
          <div className={styles.bulkTop}>
            <div className={styles.bulkTitle}>
              <RiFileList3Line size={14} />
              Bulk Create
            </div>

            <Button
              size="sm"
              className={styles.generateBtn}
              onClick={handleBulkCreate}
            >
              Generate
            </Button>
          </div>

          <Row className="g-2 mb-2">
            <Col lg={4}>
              <Form.Select
                className={styles.select}
                value={type}
                onChange={(e) =>
                  setType(e.target.value)
                }
              >
                <option
                  value={
                    TYPES.ONLY_SPECIFICATION
                  }
                >
                  Only Specification
                </option>

                <option
                  value={
                    TYPES.TITLE_SPECIFICATION
                  }
                >
                  Title + Specification
                </option>

                <option value={TYPES.FULL}>
                  Main Title + Title +
                  Specification
                </option>
              </Form.Select>
            </Col>

            <Col lg={8}>
              <div className={styles.exampleText}>
                {type ===
                  TYPES.ONLY_SPECIFICATION &&
                  "Example: 180 GSM Cotton Fabric"}

                {type ===
                  TYPES.TITLE_SPECIFICATION &&
                  "Example: Color | Red"}

                {type === TYPES.FULL &&
                  "Example: Camera | Flash Type | LED"}
              </div>
            </Col>
          </Row>

          <Form.Control
            as="textarea"
            rows={4}
            value={bulkText}
            placeholder="Paste bulk specification data..."
            className={styles.bulkTextarea}
            onChange={(e) =>
              setBulkText(e.target.value)
            }
          />
        </Card.Body>
      </Card>

      {/* Desktop Header */}

      <div
        className={`${styles.tableHeader} ${
          type === TYPES.FULL
            ? styles.gridFull
            : type ===
              TYPES.TITLE_SPECIFICATION
            ? styles.gridTwo
            : styles.gridSingle
        }`}
      >
        {type === TYPES.FULL && (
          <div>Main Title</div>
        )}

        {type !==
          TYPES.ONLY_SPECIFICATION && (
          <div>Title</div>
        )}

        <div>Specification</div>

        <div className={styles.actionCol}>
          Action
        </div>
      </div>

      {/* Rows */}

      <div className={styles.rowsWrapper}>
        {specifications.map((item, index) => (
          <div
            key={index}
            className={`${styles.specificationRow} ${
              type === TYPES.FULL
                ? styles.gridFull
                : type ===
                  TYPES.TITLE_SPECIFICATION
                ? styles.gridTwo
                : styles.gridSingle
            }`}
          >
            {/* Main Title */}

            {type === TYPES.FULL && (
              <input
                type="text"
                value={item.mainTitle}
                placeholder="Main title"
                className={styles.input}
                onChange={(e) =>
                  handleChange(
                    index,
                    "mainTitle",
                    e.target.value
                  )
                }
              />
            )}

            {/* Title */}

            {type !==
              TYPES.ONLY_SPECIFICATION && (
              <input
                type="text"
                value={item.title}
                placeholder="Title"
                className={styles.input}
                onChange={(e) =>
                  handleChange(
                    index,
                    "title",
                    e.target.value
                  )
                }
              />
            )}

            {/* Specification */}

            <textarea
              rows={1}
              value={item.specification}
              placeholder="Specification"
              className={styles.textarea}
              onChange={(e) =>
                handleChange(
                  index,
                  "specification",
                  e.target.value
                )
              }
            />

            {/* Delete */}

            <button
              className={styles.deleteBtn}
              onClick={() =>
                removeRow(index)
              }
              type="button"
            >
              <RiDeleteBin6Line size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductSpecification;